import {
  compose,
  css,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'
import { mainContainerWidths, narrowContainerWidths } from './containerWidths'

export type MainSectionProperty = 'default' | 'narrow'

export interface MainSectionProps extends FlexboxProps, LayoutProps, SpaceProps {
  variant?: MainSectionProperty
}

const defaultProps = withDefaultProps<MainSectionProps>({
  variant: 'default',
})

// TODO [TM]: not a great name, implies both <main> and <section>
export const MainSection = styled.section.attrs<MainSectionProps>(
  defaultProps,
)<MainSectionProps>(
  css({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    mx: 'auto',
  }),
  variant({
    scale: 'MainSection',
    variants: {
      default: {
        width: mainContainerWidths,
        minWidth: mainContainerWidths,
      },
      narrow: {
        width: narrowContainerWidths,
        minWidth: narrowContainerWidths,
      },
    },
  }),
  compose(flexbox, space, layout),
)
